import { render, staticRenderFns } from "./UsersTable.vue?vue&type=template&id=35446fe5&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./UsersTable.vue?vue&type=style&index=0&id=35446fe5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35446fe5",
  null
  
)

export default component.exports